// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__HEQdd","spinner":"MGLoader_spinner__OG30U","mg-loader-spin":"MGLoader_mg-loader-spin__e4+Oe"};